import React from "react";
import "./GradientButton.css";

const GradientButton = ({ onClick, children, style = {} }) => {
    return (
        <button style={style} className="gradient-button" onClick={onClick}>
            <div className="gradient-button__text">{children}</div>
        </button>
    );
};

export default GradientButton;
